var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMildRain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.644,
    height: 36.104,
    viewBox: "0 0 34.644 36.104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mid_rain",
    transform: "translate(-18.678 -17.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28147",
    "data-name": "Path 28147",
    d: "M40.714,18.49a10.2,10.2,0,0,0-8.681,4.8A7.51,7.51,0,0,0,24.3,27.142a5.936,5.936,0,0,0-5.62,5.921c0,2.936,2.18,5.25,5.554,5.893,2.206.421,5.4.577,11.768.577a105.645,105.645,0,0,0,12.019-.555c3.172-.372,5.3-2.591,5.3-5.522a5.493,5.493,0,0,0-2.359-4.52l0-.194A10.263,10.263,0,0,0,40.714,18.49Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28148",
    "data-name": "Path 28148",
    d: "M26.822,51.51a1,1,0,0,1-.937-1.351l.75-2a1,1,0,0,1,1.873.7l-.75,2a1,1,0,0,1-.936.648Z",
    fill: "#45abff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28149",
    "data-name": "Path 28149",
    d: "M29.072,45.51a1,1,0,0,1-.937-1.351l.75-2a1,1,0,0,1,1.873.7l-.75,2a1,1,0,0,1-.936.648Z",
    fill: "#45abff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28150",
    "data-name": "Path 28150",
    d: "M40.571,51.51a1,1,0,0,1-.937-1.351l.751-2a1,1,0,0,1,1.873.7l-.751,2a1,1,0,0,1-.936.648Z",
    fill: "#45abff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28151",
    "data-name": "Path 28151",
    d: "M42.822,45.51a1,1,0,0,1-.937-1.35l.749-2a1,1,0,1,1,1.873.7l-.749,2a1,1,0,0,1-.936.649Z",
    fill: "#45abff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28152",
    "data-name": "Path 28152",
    d: "M33.2,53.51a1,1,0,0,1-.937-1.351l.75-2a1,1,0,0,1,1.873.7l-.75,2a1,1,0,0,1-.936.648Z",
    fill: "#45abff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28153",
    "data-name": "Path 28153",
    d: "M35.447,47.51a1,1,0,0,1-.937-1.351l.75-2a1,1,0,0,1,1.873.7l-.75,2a1,1,0,0,1-.936.648Z",
    fill: "#45abff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28154",
    "data-name": "Path 28154",
    d: "M48.843,30.1a8.32,8.32,0,0,0,.121-1.357,8.248,8.248,0,1,0-15.9-3.088,5.5,5.5,0,0,0-7.479,3.619,3.872,3.872,0,0,0-.981-.138,3.929,3.929,0,0,0-3.929,3.929c0,2.17,1.744,3.512,3.929,3.929s5.518.542,11.393.542a103.934,103.934,0,0,0,11.786-.542c2.131-.25,3.536-1.583,3.536-3.536A3.525,3.525,0,0,0,48.843,30.1Z",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28155",
    "data-name": "Path 28155",
    d: "M24.607,31.167a3.917,3.917,0,0,1,.981.138,5.5,5.5,0,0,1,7.479-3.619,8.244,8.244,0,0,1,15.824,2.045,7.721,7.721,0,0,0,.073-.992,8.248,8.248,0,1,0-15.9-3.088,5.5,5.5,0,0,0-7.479,3.619,3.872,3.872,0,0,0-.981-.138,3.929,3.929,0,0,0-3.929,3.929,3.607,3.607,0,0,0,.154,1,3.919,3.919,0,0,1,3.775-2.9Z",
    fill: "#e0e0e0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMildRain);
export default __webpack_public_path__ + "static/media/mild_rain.bbd81c2f94a5578ceee87534726d0ece.svg";
export { ForwardRef as ReactComponent };